import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import type { CustomerUserOrganisation } from 'api';
import { getCustomerOrganisations } from 'api';

import { useOrganisationId } from 'hooks/context';
import { useRedirectTo } from 'hooks/useRedirectTo';

import { LoggingIn } from 'components/ui/organisms/LoggingIn';

export const OrganisationsLoadingTransition = () => {
  const { navigateWithRedirectTo, redirectTo, setRedirectTo } = useRedirectTo();
  const navigate = useNavigate();
  const organisationId = useOrganisationId();

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getCustomerOrganisations();
        const organisations: CustomerUserOrganisation[] =
          response.organisations;

        if (organisations.length === 0) {
          navigate('/no-organisation');

          return;
        }

        const organisationFromRedirect =
          redirectTo &&
          organisations.find((o) => o.id.toString() == organisationId);

        if (!organisationFromRedirect) setRedirectTo(null);

        const organisation =
          organisationFromRedirect ||
          organisations.find((o) => o.default) ||
          organisations[0];

        navigateWithRedirectTo(
          `/org/${organisation.id}/login_transition`,
          {
            state: { loggingIn: true }
          },
          organisationFromRedirect ? redirectTo : null
        );
      } catch (_) {
        navigate('/no-organisation');
      }
    };

    load();
  }, []);
  return <LoggingIn />;
};
